<script setup lang="ts">
defineProps<{
  event: EventCard;
  titleTag: "h1" | "h2" | "h3";
}>();
</script>

<template>
  <div
    data-event-card
    class="flex h-min w-full max-w-90 flex-col gap-2 rounded-2xl bg-(--event-background) p-5 pb-8 text-green-50"
    :class="event.eventType"
  >
    <CardsEventCover :event="event" sizes="500px" />
    <UiCommonsTag :event="event" />
    <CardsEventTitle
      :event="event"
      :tag="titleTag"
      class="text-base font-medium xs:text-xl"
    />
    <CardsEventDates :event="event" class="gap-4!" />
    <CardsEventLocation :event="event" class="gap-4!" />
    <CardsEventVideoLink :event="event" class="gap-4!" />
    <CardsEventExternalSite :event="event" class="gap-4!" />
  </div>
</template>

<style scoped>
[data-event-card]:hover {
  background-color: color-mix(in oklab, var(--event-background) 100%, white 30%);
}
</style>
